import React from 'react';
import { messages } from '../../../../../../messages';
import { phoneNumberMask } from '../../../../../../Util/helper';
import NumberFormat from 'react-number-format';
import '../Admins.css';
import { LoaderMini } from '../../../../../../Util/Loader';
export default function AddEditModalContent({ formData, handleFormChange, errors, formSubmitted, checkingEmail }) {
    return <>
        <div className="add-adminModal add-admin-modal">
            <div className="input-field">
                <label>First Name<sup>*</sup></label>
                <input type="text" name="first_name" value={formData.first_name} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["firstName"]}</span>}
            </div>
            <div className="input-field">
                <label>Last Name<sup>*</sup></label>
                <input type="text" name="last_name" value={formData.last_name} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["lastName"]}</span>}
            </div>
            <div className="input-field input-field-email">
                <label>Email<sup>*</sup></label>
                <div className="email-spinner-wrapper">
                    <input type="text" name="email" value={formData.email} onChange={handleFormChange} />
                    {checkingEmail && <div className="spinner"><LoaderMini /></div>}
                </div>
                    {(formSubmitted || errors["email"] === messages.email_taken) && <span className="error">{errors["email"]}</span>}
            </div>
            <div className="input-field" >
                <label>Primary Phone</label>
                <NumberFormat format={phoneNumberMask} mask="_" name="cell_phone" value={formData.cell_phone} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["cellPhone"]}</span>}
            </div>
            <div className="input-field">
                <label>Secondary Phone</label>
                <NumberFormat format={phoneNumberMask} mask="_" name="secondary_phone" value={formData.secondary_phone} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["secondaryPhone"]}</span>}
            </div>
            <div className="input-field">
                <label>Password<sup>*</sup></label>
                <input type="password" name="password" value={formData.password} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["password"]}</span>}
            </div>
            <div className="input-field">
                <label>Confirm Password<sup>*</sup></label>
                <input type="password" name="confirm_password" value={formData.confirm_password} onChange={handleFormChange} />
                {formSubmitted && <span className="error">{errors["confirmPassword"]}</span>}
            </div>
        </div>
    </>
}